module.exports = __webpack_public_path__ + "static/img/5.f5c065f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/5.png
// module id = p0hj
// module chunks = 4